import { Component, OnInit, ViewChild, ElementRef, ViewChildren, QueryList, Input } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { FormBuilder, FormArray, Validators, NgForm, AbstractControl, FormGroup } from '@angular/forms';
import { CommonServiceService } from 'src/app/shared/common-service.service';
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';
import { ContraService } from '../services/contra.service';
import * as moment from 'moment-timezone';
import { FormCanDeactivate } from 'src/app/shared/form-can-deactivate/form-can-deactivate';
import { AllowIn, ShortcutInput } from 'ng-keyboard-shortcuts';
import { InvoiceServicesService } from '../../invoice/flight/services/invoice-services.service';

@Component({
	selector: 'app-add-entry-contra',
	templateUrl: './add-entry-contra.component.html',
	styleUrls: ['./add-entry-contra.component.scss'],
	providers: [ContraService]
})
export class AddEntryContraComponent extends FormCanDeactivate  implements OnInit {
	@Input() data
	@ViewChild('form')
 	form: NgForm;
	contraData: any;
	contraArray: FormArray
	updateContraForm: any;
	selectedDate;
	contraId: any;
	keyword = "name"
	sendEmailForm: FormGroup;

	showMessage: boolean = false;
	alertType = '';
	message: string = ``;

	accountList = []
	ledgerList = []
	attachmentFile: File | null = null;
	approvedByArr: any[][] = [];
	osaka_custom_field_config: string = 'false'



	@ViewChildren('accountAc') accountAc: QueryList<ElementRef>;
	@ViewChildren('subLedgerAc') subLedgerAc: QueryList<ElementRef>;
	// @ViewChild('accountAc') accountAc;
	// @ViewChild('subLedgerAc') subLedgerAc;
	lastInputIndex = 8;
	@ViewChild('confirmModal',{static:true}) confirmModal : ElementRef 
	@ViewChild('closeModal',{static:true}) closeModal : ElementRef

	@ViewChild('confirmDeleteModal',{static:true}) confirmDeleteModal : ElementRef
	@ViewChild('closeDeleteModal',{static:true}) closeDeleteModal : ElementRef
	@ViewChild('deleteConfirmBtn',{static:true}) deleteConfirmBtn : ElementRef

	@ViewChild('confirmUpdateModal',{static:true}) confirmUpdateModal : ElementRef
	@ViewChild('closeUpdateModal',{static:true}) closeUpdateModal : ElementRef

	@ViewChild('updateConfirmBtn',{static:true}) updateConfirmBtn : ElementRef
	@ViewChild('updateButton',{static:true}) updateButton : ElementRef
	@ViewChild('openEmailModal') openEmailModal;
	@ViewChild('closeSendEmailModal') closebutton;

	shortcuts: ShortcutInput[] = [];
	currentOpenedModal = ''
	minDate;
  	maxDate;
	  dateFormat = 'YYYY-MM-DD';
	  isLocaleDateFormat: boolean = true;
	acCurrencyCode = ''
	isTenantIndian: boolean = true;
	financialYearDiff = false;
	constructor(
		private invoiceService: InvoiceServicesService,
		public commonService: CommonServiceService,
		private spinner: NgxSpinnerService,
		private fb: FormBuilder,
		private route: ActivatedRoute,
		public contraService: ContraService

	) {
		super()
		this.updateContraForm = this.fb.group({
			amountDiff: [0],
			totalCredit: [0],
			totalDebit: [0],
			contra_date: [moment().format('YYYY-MM-DD'),Validators.required],
			contraArray: this.fb.array([]),
			currency_code: [''],
			currency_rate: [''],
			approved_by_employee_name: [''],
			received_in: [''],
			created_by_employee_name: [''],
			created_by_employee_code: [""],
			approved_by_employee_code: [""]


		});
		this.sendEmailForm = this.fb.group({
			toEmails: ["",Validators.required],
			bccEmails: [''],
			ccEmails:[''],
			subject:[''],
			body:['']
		})
		this.contraArray = this.updateContraForm.get("contraArray") as FormArray;
		this.route.paramMap.subscribe(params => {
			this.contraId = params['params'].id
			// this.getJv()
		});

	}

	async ngOnInit() {
		/** spinner starts on init */
		this.spinner.show();

		setTimeout(() => {
			/** spinner ends after 5 seconds */
			this.spinner.hide();
		}, 1000);

		if(this.data) {
			this.contraId = this.data.contra_code
		}

		this.minDate = moment().subtract(15, 'days').format('YYYY-MM-DD')
		try {
			let empConfiguration = this.commonService.employeeConfiguration;
				if(!empConfiguration || empConfiguration.length == 0){
					let loggedInUser = JSON.parse(localStorage.okountUserInfo);
					empConfiguration = await this.commonService.getConfiguration(loggedInUser.accountcode)
				}
		} catch (error) {
			
		}

		let globalSettingConfig = this.commonService.globalSettingConfig;
		if(!globalSettingConfig || globalSettingConfig.length == 0) {
			globalSettingConfig = await this.commonService.getGlobalSettings();
		}
		
		let transaction_config = globalSettingConfig.filter(el=>el.group=='TRANSACTION')
		if(transaction_config && transaction_config.length>0){      
		 
      let dateConfig = await this.commonService.getDateFormat('date_format')
        this.dateFormat = dateConfig.dateFormat
        this.isLocaleDateFormat = dateConfig.isLocaleDateFormat
		let custom_feild_config = transaction_config[0].json_doc["value"].filter(el=>el.key=='Custom Osaka Field On Financial Transactions')
		if(custom_feild_config && custom_feild_config.length){
			this.osaka_custom_field_config = custom_feild_config[0].value
		}
		}

		this.isTenantIndian = this.commonService.checkTenantIndian()

		this.contraDateValidation();

		if (this.contraId != undefined) {
			this.getContra()
		}
		this.commonService.selectedInput.next(0)

	}

	validateDate(){
		return (control: AbstractControl) => {
			let valid = true
			if(this){
				if (moment(control.value).isBefore(this.minDate) || moment(control.value).isAfter(this.maxDate)) {
					if(this.contraData && this.contraData.length > 0 && this.contraData[0].contra_date && moment(control.value,'YYYY-MM-DD').isSame(moment(this.contraData[0].contra_date,'YYYY-MM-DD'))){
						valid = true
					}else{
						valid = false
					}
				}
			}
			return !valid ? {contra_date: {value: control.value}} : null;
		};
	}

	ngAfterViewInit(){

		this.shortcuts.push(			
			{
				key: "alt + e",
				allowIn: [AllowIn.Textarea, AllowIn.Input, AllowIn.Select],
				label: "Update Contra Entry",
				description: "Update Contra Entry",
				
				command: (e)=>{
				console.log(e)	
			if(document.getElementById("modify_contra_btn")){

				document.getElementById("modify_contra_btn").click()
				setTimeout(() => {
				document.getElementsByTagName('body')[0].click()
				}, 100);
			}
					},
					preventDefault: true
			},
			{
				key: "alt + d",
				allowIn: [AllowIn.Textarea, AllowIn.Input, AllowIn.Select],
				label: "Delete Contra Entry",
				description: "Delete Contra Entry",
				
				command: (e)=>{
				console.log(e)	
			if(document.getElementById("delete_contra_btn")){

				document.getElementById("delete_contra_btn").click()
				setTimeout(() => {
				document.getElementsByTagName('body')[0].click()
				}, 100);
			}
					},
					preventDefault: true
			},
			{
				key: "alt + l",
				allowIn: [AllowIn.Textarea, AllowIn.Input, AllowIn.Select],
				label: "Activity Log Of Contra Entry",
				description: "Activity Log Of Contra Entry",
				
				command: (e)=>{
				console.log(e)	
			if(document.getElementById("contra_activity_log_btn")){

				document.getElementById("contra_activity_log_btn").click()
				setTimeout(() => {
				document.getElementsByTagName('body')[0].click()
				}, 100);
			}
					},
					preventDefault: true
			},
			{
				key: "alt + plus",
				allowIn: [AllowIn.Textarea, AllowIn.Input, AllowIn.Select],
				label: "Add New Contra Row",
				description: "Add New Contra Row",
				
				command: (e)=>{
				console.log(e)	
					this.addContraRow()
					setTimeout(() => {
						document.getElementsByTagName('body')[0].click()
						}, 100);
					},
					preventDefault: true
			},
			{
				key: "alt + -",
				allowIn: [AllowIn.Textarea, AllowIn.Input, AllowIn.Select],
				label: "Delete Last Contra Row",
				description: "Delete Last Contra Row",
				
				command: (e)=>{
				console.log(e)	
				if(this.contraArray.length>0){
					this.removeContraRow(this.contraArray.length-1)
					setTimeout(() => {
					document.getElementsByTagName('body')[0].click()
					}, 100);
				}
						},
						preventDefault: true
			},
			{
				key: "alt + y",
				allowIn: [AllowIn.Textarea, AllowIn.Input, AllowIn.Select],
				label: "Clicked On Yes Button",
				description: "Clicked On Yes Button",
				
				command: (e)=>{
				if(this.currentOpenedModal=='update'){
					this.submit(this.updateContraForm.value)
					setTimeout(() => {
						document.getElementsByTagName('body')[0].click()
						}, 100);
				}else if(this.currentOpenedModal=='delete'){
					this.deleteContra(this.contraId)
					setTimeout(() => {
						document.getElementsByTagName('body')[0].click()
						}, 100);
				}
				this.currentOpenedModal = ''
					},
					preventDefault: true
			},
			{
				key: "alt + n",
				allowIn: [AllowIn.Textarea, AllowIn.Input, AllowIn.Select],
				label: "Clicked On No Button",
				description: "Clicked On No Button",
				
				command: (e)=>{
				if(this.currentOpenedModal=='update'){
					this.closeUpdateConfirmModal()
					setTimeout(() => {
						document.getElementsByTagName('body')[0].click()
						}, 100);
				}else if(this.currentOpenedModal=='delete'){
					this.closeDeleteConfirmModal()
					setTimeout(() => {
						document.getElementsByTagName('body')[0].click()
						}, 100);
				}
				this.currentOpenedModal = ''
					},
					preventDefault: true
			},
			
	  )
	}

	openConfirmModal(lastIndex,addIndex) :  void{
		this.hideError()
		this.confirmModal.nativeElement.click()
		this.moveToTab(lastIndex,addIndex)
	}
	closeConfirmModal() :  void{
		console.log('Modal Closed')
		if (this.closeModal) {
			this.closeModal.nativeElement.click()
		}
	}

	focusAccountAc(e: Event,index) {
		e.stopPropagation();
		// this.accountAc["_results"][(<HTMLInputElement>e.target).tabIndex%(+this.accountAc["_results"].length-1)+1].el.nativeElement.focus();
		if (this.accountAc["_results"][index]) {
			this.accountAc["_results"][index].focus()
		}

	  }
	  focusSubLedgerAC(e: Event,index) {
		e.stopPropagation();
		if (this.subLedgerAc["_results"][index]) {
			this.subLedgerAc["_results"][index].focus()
		}
	  }

	movetoIndex(index){
		this.lastInputIndex = ((index+1)*8)
		setTimeout(() => {
			this.commonService.selectedInput.next(this.lastInputIndex+1)
		}, 100);
	}
	moveToTab(lastInputIndex,addIndex){
		this.commonService.selectedInput.next(lastInputIndex+addIndex)
	}

	addContraRow() {
		this.closeConfirmModal()
		this.contraArray.push(this.buildContra());
	}

	removeContraRow(index) {
		this.contraArray.removeAt(index);
		this.movetoIndex(this.contraArray.length - 1)
	}

	getAccounts(value, i) {
		return new Promise((resolve, reject) => {
			let searchType = 'general'
			if (value.length > 2 && searchType != null && searchType != '') {
			this.contraService.getMethod(`${searchType}/autocomplete?name_like=${value.toUpperCase()}&status=active`).subscribe(res => {
				this.contraService.accountList[i] = res
				resolve(res)
			}, err => {
				resolve("")
			})
		}
		})
	}

	getLedgers(url, index) {
		return new Promise((resolve, reject) => {
			this.contraService.getMethod(url).subscribe(res => {
				this.contraService.ledgerList[index] = res
				resolve(res)
			}, err => {
				resolve("")
			})
		})
	}

	get DynamicFormControls() {
		return <FormArray>this.updateContraForm.get("contraArray");
	}

	dateSelection(event) {
		let contraFormGroupControl = this.updateContraForm.controls.contraArray.controls
		this.selectedDate = moment(event).format('YYYY-MM-DD')
		for (let i = 0; i < contraFormGroupControl.length; i++) {
			const contraControl = contraFormGroupControl[i];
			contraControl.controls.contra_date.setValue(this.selectedDate)
		}
	}

	searchAccount(value, i) {
		try {
			let searchType = 'general'
			if (value.length > 2 && searchType != null && searchType != '') {
				this.commonService.getRequest(`${environment.okountUrl}/${searchType}/autocomplete?name_like=${value.toUpperCase()}&status=active`).subscribe(res => {
					
					this.accountList[i] = res
					console.log(this.accountList)
				});
			}
		} catch (error) {
			console.log('Error occured while account autoo complete search : ',error)
		}
	}
	selectAccount(data, formControlName, index) {
		this.updateContraForm.controls.contraArray.controls[index].controls[formControlName].setValue(data.account_code)
	}
	searchLedger(value, i) {
		try {
			let searchType = 'general'
			if (value.length > 2 && searchType != null && searchType != '') {
				this.commonService.getRequest(`${environment.okountUrl}/${searchType}/autocomplete?name_like=${value.toUpperCase()}&status=active`).subscribe(res => {
					this.ledgerList[i] = res
					console.log(this.ledgerList)
				});
			}
		} catch (error) {

		}
	}
	selectLedger(data, formControlName, index) {
		this.updateContraForm.controls.contraArray.controls[index].controls[formControlName].setValue(data.account_code)
	}

	calculateDiff(index, formControlName) {
		if (formControlName == 'debit') {
			this.updateContraForm.controls.contraArray.controls[index].controls.credit.setValue('0')
		}
		if (formControlName == 'credit') {
			this.updateContraForm.controls.contraArray.controls[index].controls.debit.setValue('0')
		}
		let totalDebit = this.getTotal('debit')
		let totalCredit = this.getTotal('credit')
		let difference = Number((totalDebit - totalCredit).toFixed(2))
		this.updateContraForm.controls.amountDiff.setValue(difference)
		this.updateContraForm.controls.totalDebit.setValue(totalDebit)
		this.updateContraForm.controls.totalCredit.setValue(totalCredit)
	}

	getTotal(amountType) {
		let amount = 0
		if (this.updateContraForm.controls.contraArray.controls.length > 0) {
			let controls = this.updateContraForm.controls.contraArray.controls
			for (let index = 0; index < controls.length; index++) {
				const element = controls[index];
				amount += Number(element.controls[amountType].value)
			}
		}
		return amount
	}


	// doTransactionEntry(entries) {
	// 	this.commonService.postRequest(`${environment.okountUrl}/v3/jv`, entries).subscribe(res => {
	// 		console.log(res)
	// 	}, err => {
	// 	})
	// }

	buildContra() {
		let currentUser = JSON.parse(localStorage.getItem('okountUserInfo'))
		let date = moment().format('YYYY-MM-DD')
		if (this.selectedDate != undefined) {
			date = this.selectedDate
		}
		return this.fb.group({
			"id": [""],
			"account_type": [""],
			"account_code": [""],
			"account_code_name": [''],
			"contra_date": [date, Validators.required],
			"account_balance": [""],
			"sub_ledger_type": [""],
			"sub_ledger_code": [""],
			"sub_ledger_code_name": [""],
			"debit": ["0"],
			"credit": ["0"],
			"narration_1": [""],
			"narration_2": [""],
			"remarks_1": [""],
			"remarks_2": [""],
			"last_updated_by_id": [currentUser.id], // FIX ME
			"last_updated_by_name": [currentUser.name], // FIX ME
			"last_updated_by_code": [currentUser.accountcode], // FIX ME
			"approved_by_employee_name": [""],
			"approved_by_employee_code": [""],
			"received_in": [""],
			"created_by_employee_name": [""],
			"created_by_employee_code": [""],
			
		});
	}

	getContra() {
		this.commonService.getOkount(`contra?contra_code=${this.contraId}`).subscribe(async (res) => {
			if (res && res['data']) {
				this.contraData = res['data']
				
				if(res && res['accounting_company']) {
					this.acCurrencyCode = res['accounting_company']['currency_code'] ? res['accounting_company']['currency_code'] : ''
				}

				const commonHeader = this.contraData[0] || {};
				console.log(commonHeader,'uuuuuuuuuuuuuuuuuuuu');
				let loggedInUser = JSON.parse(localStorage.okountUserInfo);

				this.updateContraForm.patchValue({
					approved_by_employee_name: commonHeader.approved_by_employee_name || '',
					approved_by_employee_code: commonHeader.approved_by_employee_code || '',
					received_in: commonHeader.received_in || '',
					created_by_employee_name: commonHeader.created_by_employee_name || loggedInUser?.name,
					created_by_employee_code: commonHeader.created_by_employee_code || loggedInUser?.accountcode,
				});

				for (const key in this.contraData) {
					if (this.contraData.hasOwnProperty(key)) {
						const element = this.contraData[key];
						let accounts = await this.getAccounts(element.account_code, key)
						if (element.sub_ledger_type != null) {
							let ledgers = await this.getLedgers(element.sub_ledger_type, key)
						}
						this.addContraRow()
						await this.setContraData(element, key)
						this.calculateDiff(key,Number(element.credit) ? 'credit' : 'debit')
						this.lastInputIndex = ((this.contraData.length)*8)
					}
				}
			}
			console.log(this.contraData)
		})
	}

	setContraData(data, index) {
		console.log(data,'jjjjjj');
		
		if (this.updateContraForm != undefined && data != undefined) {
			this.updateContraForm.controls.contraArray.controls[index].controls.id.setValue(data.id)
			this.updateContraForm.controls.contraArray.controls[index].controls.account_type.setValue(data.account_type)
			this.updateContraForm.controls.contraArray.controls[index].controls.account_code.setValue(data.account_code)
			try {
				this.updateContraForm.controls.contra_date.setValue(moment(data.contra_date).format('YYYY-MM-DD'))
				
				this.updateContraForm.controls.currency_code.setValue(data.currency_code);
				this.updateContraForm.controls.currency_rate.setValue(data.currency_rate);

				this.updateContraForm.controls.contraArray.controls[index].controls.contra_date.setValue(moment(data.contra_date).format('YYYY-MM-DD'))
			} catch (error) {
			}
			if (this.contraService.accountList.length > 0) {
				let selectedAccount = this.contraService.accountList[index].filter(option => {
					return option.account_code == data.account_code;
				});
				if (selectedAccount.length > 0) {
					this.accountList[index] = selectedAccount
					this.updateContraForm.controls.contraArray.controls[index].controls.account_code_name.setValue(selectedAccount[0].name)
				}
			}
			let selectedLedger = [];
			if(this.contraService.ledgerList.length > 0 && this.contraService.ledgerList[index] != undefined) {

				selectedLedger = this.contraService.ledgerList[index].filter(option => {
					return option.account_code == data.sub_ledger_code;
				});
			}
			if (selectedLedger.length > 0) {
				this.ledgerList[index] = selectedLedger
				this.updateContraForm.controls.contraArray.controls[index].controls.sub_ledger_code_name.setValue(selectedLedger[0].name)
			}
			this.updateContraForm.controls.contraArray.controls[index].controls.sub_ledger_type.setValue(data.sub_ledger_type)
			this.updateContraForm.controls.contraArray.controls[index].controls.sub_ledger_code.setValue(data.sub_ledger_code)
			this.updateContraForm.controls.contraArray.controls[index].controls.account_balance.setValue(data.account_balance)
			this.updateContraForm.controls.contraArray.controls[index].controls.debit.setValue(data.debit)
			this.updateContraForm.controls.contraArray.controls[index].controls.credit.setValue(data.credit)
			this.updateContraForm.controls.contraArray.controls[index].controls.narration_1.setValue(data.narration_1)
			this.updateContraForm.controls.contraArray.controls[index].controls.narration_2.setValue(data.narration_2)
			this.updateContraForm.controls.contraArray.controls[index].controls.remarks_1.setValue(data.remarks_1)
			this.updateContraForm.controls.contraArray.controls[index].controls.remarks_2.setValue(data.remarks_2)
			this.updateContraForm.controls.contraArray.controls[index].controls.last_updated_by_id.setValue(data.last_updated_by_id)
			this.updateContraForm.controls.contraArray.controls[index].controls.last_updated_by_name.setValue(data.last_updated_by_name)
			this.updateContraForm.controls.contraArray.controls[index].controls.last_updated_by_code.setValue(data.last_updated_by_code)

			// if (this.jvData.gst_expiry_date != null && this.jvData.gst_expiry_date != '') {
			// 	this.updateContraForm.controls.gst_expiry_date.setValue(moment(this.jvData.g.format('YYYY-MM-DD')st_expiry_date))
			// }

		}
	}

	async submit(value) {
		const invalid = [];
		const controls = this.updateContraForm.controls;
		for (const name in controls) {
			if (controls[name].invalid && name != "contraArray") {
				invalid.push(name);
			}
		}
		!this.financialYearDiff && await this.initDateValidation();
		
		if(invalid.length > 0) {
			window.scroll(0,0)
			this.showMessage = true;
			this.alertType = 'error-box';
			this.message = `Invalid field ${invalid[0]} ${invalid.length > 1 ? `+${invalid.length-1}` : ''}`
			this.spinner.hide()
			this.closeUpdateConfirmModal()
			return false 
		}
		this.closeUpdateConfirmModal()
		this.hideError()
		if (value.amountDiff != 0) {
			return false
		}
		let date = value.contra_date
		if(this.updateContraForm.invalid){
			this.showMessage = true
			this.alertType = 'error-box';
			this.message = 'Invalid Data, please validate data and try again.'
			return false
		}
		for (let i = 0; i < value.contraArray.length; i++) {
			value.contraArray[i].contra_date = date;
		}

			value.contraArray.forEach(item => {
				if (typeof value.approved_by_employee_name === "object" && value.approved_by_employee_name !== null) {
					item.approved_by_employee_name = value.approved_by_employee_name.name || "";
					item.approved_by_employee_code = value.approved_by_employee_name.account_code || "";
					item.created_by_employee_name = value.created_by_employee_name || "";
					item.created_by_employee_code = value.created_by_employee_name || "";
				} else {
					item.approved_by_employee_name = value.approved_by_employee_name || "";
					item.approved_by_employee_code = value.approved_by_employee_code || "";
					item.created_by_employee_name = value.created_by_employee_name || "";
					item.created_by_employee_code = value.created_by_employee_code || "";
				}
		
				item.received_in = value.received_in || "";
			});
		
		// await this.dateSelection(date)
		this.commonService.selectedInput.next(this.lastInputIndex+1)
		this.spinner.show()

		if(controls.currency_rate.value && controls.currency_code.value) {
			for(let item of value.contraArray){
				item['currency_rate'] = controls.currency_rate.value;
				item['currency_code'] = controls.currency_code.value;
			}
		}		

		this.commonService.putRequest(`${environment.okountUrl}/contra/${this.contraId}`, value.contraArray).subscribe(async (res) => {
			let contra_code = res[0].contra_code
			this.showMessage = true
			res['old_transaction_no'] = contra_code
			// await this.doTransactionEntry(res)
			this.alertType = 'success-box';
			this.message = `Contra Updated successfully.`
			this.spinner.hide();
		}, err => {
			this.showMessage = true
			this.alertType = 'error-box';
			this.message = 'Failed to update Contra.'
			if( err['error']['message']){
				this.message = err['error']['message']
			  }
			this.spinner.hide();
		})
	}

	reset() {
		this.updateContraForm.reset()
		this.contraArray.controls = []
		this.addContraRow()
	}

	openActivity(){
		let path=`${environment.name == 'v3-stage' || environment.name == 'v3-prod' ? '/v3/' : "/"}#/activity/activity-summary/contra/${this.contraId}`;
		if(window.location.protocol != 'file:'){
			window.open(path,'_blank')
		}else{
			var customeEventHandler = new CustomEvent("handle-window-open", {
				"detail": {
					hashPath : path
				}
			  });
			window.dispatchEvent(customeEventHandler)
		}
	}

	closeWindow() {
		window.close();
	}

	deleteContra(contra_code){
		this.closeDeleteConfirmModal()
		this.hideError()
		this.commonService.selectedInput.next(this.lastInputIndex+1)
		this.commonService.deleteRequest(`${environment.okountUrl}/contra?contra_code=${contra_code}`).subscribe(res=>{
			this.showMessage = true
			this.alertType = 'success-box';
			this.message = `Contra Deleted`
		},err=>{
			debugger
			this.showMessage = true
			this.alertType = 'error-box';
			this.message = `Failed to delete Contra.`
		})
	}

	hideError(){
		this.showMessage = false
	}
	resetCurrentModalType(){
		this.currentOpenedModal = ''
	}
	openDeleteConfirmModal(){
		if(this.commonService.gstFiledDate) {
			if(moment(this.commonService.gstFiledDate).isSameOrAfter(moment(this.contraData[0].contra_date).format('YYYY-MM-DD')) || moment(this.commonService.gstFiledDate).isSameOrAfter(moment(this.updateContraForm.controls.contra_date.value).format('YYYY-MM-DD'))) {
				this.showMessage = true
				this.spinner.hide()
				this.alertType = "error-box"
				this.message = 'Not Allowed to delete the contra.'
				return false;
			}
		}
		
		this.closeOpenedModals('delete')
		this.currentOpenedModal = 'delete'
		this.confirmDeleteModal.nativeElement.click()
		this.commonService.selectedInput.next(this.lastInputIndex+5)
	}
	closeDeleteConfirmModal(){
		this.currentOpenedModal = ''
		this.closeDeleteModal.nativeElement.click()
	}
	
	focusDeleteConfirm(){
		this.deleteConfirmBtn.nativeElement.focus()
	}
	openUpdateConfirmModal(){

		if(this.commonService.gstFiledDate) {
			if(moment(this.commonService.gstFiledDate).isSameOrAfter(moment(this.contraData[0].contra_date).format('YYYY-MM-DD')) || moment(this.commonService.gstFiledDate).isSameOrAfter(moment(this.updateContraForm.controls.contra_date.value).format('YYYY-MM-DD'))) {
				this.showMessage = true
				this.spinner.hide()
				this.alertType = "error-box"
				this.message = 'Not Allowed to update the contra.'
				return false;
			}
		}
		
		this.closeOpenedModals('update')
		this.currentOpenedModal = 'update'
		this.confirmUpdateModal.nativeElement.click()
		this.commonService.selectedInput.next(this.lastInputIndex+7)
	}
	closeUpdateConfirmModal(){
		this.currentOpenedModal = ''
		this.closeUpdateModal.nativeElement.click()
	}

	closeOpenedModals(modalName){
		if(modalName!='delete') this.closeDeleteConfirmModal()
		if(modalName!='update') this.closeUpdateConfirmModal()
	}
	focusUpdateConfirm(){
		this.updateConfirmBtn.nativeElement.focus()
	}

	openContraActivity(contraId) {
		let path=`${environment.name == 'v3-stage' || environment.name == 'v3-prod' ? '/v3/' : "/"}#/activity/activity-summary/contra/${contraId}`
		window.open(path,'_blank')
	}

	openContraPrint(contraId) {
		let path=`${environment.name == 'v3-stage' || environment.name == 'v3-prod' ? '/v3/' : "/"}#/transactions/contra/print/${contraId}`
		window.open(path,'_blank')
	}

	openSendEmailModal(){
		let primary_email = ''
		let secondary_email = ''
		let accounting_company = this.contraData && this.contraData.length>0 && this.contraData[0].accounting_company ? this.contraData[0].accounting_company : null;
		let subject = `Contra. ${this.contraId}`
		let body = `Dear Travel Partner,\n\nPlease find Attached Contra ${this.contraId}`
		body+=`\n\nPlease do not hesitate to contact us if you have any query or concern about attached document.\n\nIt's been a pleasure to serve you.\n\nBest Regards\n\n${accounting_company?.name}\nAccounts Team`
		if(accounting_company && accounting_company.telephone){
			body += `\nContact Us on ${accounting_company.telephone}`
		}
		if(this.contraData && this.contraData.length>0 && this.contraData[0].client){
			primary_email = this.contraData[0].client.hasOwnProperty('primary_email')?this.contraData[0].client.primary_email:''
			secondary_email = this.contraData[0].client.hasOwnProperty('secondary_email')?this.contraData[0].client.secondary_email:''
		}
		this.sendEmailForm.controls.toEmails.setValue(primary_email)
		this.sendEmailForm.controls.bccEmails.setValue("")
		this.sendEmailForm.controls.ccEmails.setValue(secondary_email?.split(',').join('\n'))
		this.sendEmailForm.controls.subject.setValue(subject)
		this.sendEmailForm.controls.body.setValue(body)
		this.openEmailModal.nativeElement.click();
	}

	callTosendEmail(){
		let toEmails = this.sendEmailForm.value.toEmails
		let bccEmails = this.sendEmailForm.value.bccEmails?.split(",")
		let ccEmails = this.sendEmailForm.value.ccEmails?.split(",")
		let subject = this.sendEmailForm.value.subject
        let body = this.sendEmailForm.value.body
		if(toEmails){
			toEmails = toEmails.split(",")
			window.scrollTo(0, 0)
			let emails = {
				to_addresses:toEmails,
				cc_addresses:ccEmails,
				bcc_addresses:bccEmails
			}
			let pageUrl = `transactions/contra/print/${this.contraId}`
			const formData = new FormData();
			formData.append('email',JSON.stringify(emails))
			formData.append('page_url',pageUrl)
			formData.append('subject',subject)
			formData.append('email_body',body)
			formData.append('document_num',this.contraId)
			if(this.attachmentFile){
				formData.append('attachmentFile',this.attachmentFile)
			}
			let data = formData
			this.commonService.fileUpload(`${environment.okountUrl}/send_mail?transaction_type=contra`,data).subscribe((res : any)=> {
				this.showMessage = true;
				this.alertType = 'success-box'
				this.message = res.msg
				this.closebutton.nativeElement.click();
			},err => {
				this.showMessage = true
				this.alertType = "error-box"
				this.message = err.msg
				this.closebutton.nativeElement.click();
			 })
			}
	  }

	  async initDateValidation (){
	    this.minDate = moment().subtract(15, 'days').format('YYYY-MM-DD')
		try {
		let empConfiguration = this.commonService.employeeConfiguration;
			if(!empConfiguration || empConfiguration.length == 0){
				let loggedInUser = JSON.parse(localStorage.okountUserInfo);
				empConfiguration = await this.commonService.getConfiguration(loggedInUser.accountcode)
			}
			let config = this.commonService.getConfigurationByKey('payment')
			if(config){
				let dateConfig = config['value'].filter(data => data.key == 'minimum_update_date')
				let daysConfig = config['value'].filter(data => data.key == 'minimum_update_days')
				let dateWithMinDate = moment(dateConfig ? dateConfig[0].value : '')
				let dateWithMinDays = dateConfig && daysConfig[0].value ? moment().subtract(Number(daysConfig[0].value), 'days') : dateWithMinDate
				if(dateWithMinDays.isBefore(dateWithMinDate)){
					this.minDate = dateWithMinDate.format('YYYY-MM-DD')
				}else{
					this.minDate = dateWithMinDays.format('YYYY-MM-DD')
				}
			}
		} catch (error) {
			
		}
		this.maxDate = moment().format('YYYY-MM-DD')
		this.updateContraForm.controls.contra_date.setValidators([Validators.required,this.validateDate()])
		this.updateContraForm.controls.contra_date.updateValueAndValidity()

	}   

	onContraCurrencyChange(){
		this.updateContraForm.controls.currency_rate.setValue("");
	}
	handleAttachment(event: any) {
		this.attachmentFile = event.target.files[0];
	}

	contraDateValidation() {
		let financeYearResponse = this.commonService.checkFinancialYearValidation();
		this.financialYearDiff = financeYearResponse.isFinancialYearDiff;
		this.minDate = financeYearResponse.minDate;
		this.maxDate = financeYearResponse.maxDate;

		this.updateContraForm.controls.contra_date.setValue(this.maxDate);
		this.updateContraForm.controls.contra_date.setValidators([Validators.required, this.validateDate()]);
		this.updateContraForm.controls.contra_date.updateValueAndValidity()
	}

	resetSelection(formControlName,index) {
		this.updateContraForm.controls.contraArray.controls[index].controls[formControlName].setValue('')
		this.updateContraForm.controls.contraArray.controls[index].controls[`${formControlName}_name`].setValue('')
		if(formControlName == 'account_code'){
		  this.accountList = []
		}
		if(formControlName == 'sub_ledger_code'){
		  this.ledgerList = []
		}
	  }

	  adjustInvoices(i) {    
		let data = this.contraData[i]
		let path = `${
		  environment.name == "v3-stage" || environment.name == "v3-prod"
			? "/v3/"
			: "/"
		}#/report/adjust-balance?account_code=${data.account_code}&adjustment_reference=${data.contra_code}&reference_type=contra`;
	   
		if(window.location.protocol != 'file:') {
		  window.open(path, '_blank')
		}
	  }

	  viewAdjustedInvoices(i) {    
		let data = this.contraData && this.contraData.length > 0 && this.contraData[0] 
		let path = `${
		  environment.name == "v3-stage" || environment.name == "v3-prod"
			? "/v3/"
			: "/"
		}#/report/adjusted-invoices?account_code=${data.account_code}&adjustment_reference=${data.contra_code}&reference_type=contra`;
	   
		if(window.location.protocol != 'file:') {
		  window.open(path, '_blank')
		}
	  }
	  
	  approvedBySearch(event: any) {
		try {
		  this.invoiceService
			.searchAccount(`employee/autocomplete?name_like=${event.target.value || ''}`)
			.subscribe(
			  (res) => {
				if (!this.approvedByArr) {
				  this.approvedByArr = [];
				}
				this.approvedByArr = Array.isArray(res) ? res : [];
			  },
			  (error) => {
				this.approvedByArr = [];
				console.error(error);
			  }
			);
		} catch (error) {
		  console.error('Error in approvedBySearch:', error);
		}
	  }
	
	
	  selectApprovedBy(event: any) {
		// if (formControlName === 'approved_by_employee_name') {
		  const value = event.nzValue;
		//   if (this.contraService.updateContraForm.controls.contraArray.controls[index]) {
			this.updateContraForm.patchValue({
			  approved_by_employee_name: value?.name || '',
			  approved_by_employee_code: value?.account_code || '',
			});
		//   }
		// }
	  }
}
